import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, X } from "lucide-react";
import { api } from "../lib/api";
import { DealCard } from "../components/DealCard";
import { FadeUp } from "../components/Reveal";

export default function DealsPage({ status = "live" }) {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const [deals, setDeals] = useState([]);
  const [cats, setCats] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/deals", { params: { status, ...(category && { category }), ...(search && { q: search }) } }).then(({ data }) => setDeals(data));
    }, 300);
    return () => clearTimeout(t);
  }, [category, status, search]);

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCats(data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12">
      <FadeUp>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mb-10">
          {status === "live" ? <>TODAY'S <span className="text-[#FFCC00]">LIVE DEALS</span></> : <>COMING <span className="text-[#FF3B30]">SOON</span></>}
        </h1>
      </FadeUp>
      <div className="grid lg:grid-cols-[240px_1fr] gap-10">
        <aside>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Categories</div>
          <div className="flex lg:flex-col gap-2 flex-wrap">
            <button
              data-testid="category-filter-all"
              onClick={() => setParams({})}
              className={`text-left text-sm px-4 py-2.5 border transition-colors duration-150 ${!category ? "border-[#FFCC00] text-[#FFCC00]" : "border-[#27272A] text-white/60 hover:border-white/40"}`}
            >
              All lots
            </button>
            {cats.map((c) => (
              <button
                key={c.slug}
                data-testid={`category-filter-${c.slug}`}
                onClick={() => setParams({ category: c.slug })}
                className={`text-left text-sm px-4 py-2.5 border transition-colors duration-150 ${category === c.slug ? "border-[#FFCC00] text-[#FFCC00]" : "border-[#27272A] text-white/60 hover:border-white/40"}`}
              >
                {c.name} <span className="text-white/30">({c.deal_count})</span>
              </button>
            ))}
          </div>
        </aside>
        <div>
          <div className="flex items-center border border-[#27272A] focus-within:border-[#FFCC00] mb-8 max-w-xl">
            <Search size={16} className="ml-4 text-white/40 shrink-0" />
            <input
              data-testid="deals-search-input"
              placeholder="SEARCH LOTS — E.G. TOOLS, RETURNS, UKJ-0003…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="flex-1 bg-transparent px-4 py-3.5 text-sm outline-none placeholder:text-white/30"
            />
            {search && (
              <button data-testid="deals-search-clear" onClick={() => setSearch("")} className="px-4 text-white/40 hover:text-[#FF3B30]"><X size={16} /></button>
            )}
          </div>
          {deals.length === 0 ? (
            <div className="border border-[#27272A] p-16 text-center font-display text-2xl text-white/30" data-testid="deals-empty-state">
              {search ? `NOTHING MATCHES "${search.toUpperCase()}".` : "NO LOTS IN THIS CATEGORY RIGHT NOW."}
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-6">
              {deals.map((d, i) => <DealCard key={d.id} deal={d} index={i} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
